import { LoadState } from "../../constants/enums";
import {
  IWhatsAppTemplate,
  IWhatsAppTemplateData,
  IWhatsAppTemplateState,
} from "./whatsappTemplate.types";

export const initialWhatsAppTemplate: IWhatsAppTemplate = {
  company_outlet_uuid: "",
  company_outlet_name: "",
  name: null,
  status: null,
  reason: null,
  header: null,
  body: null,
  template_id: null,
  components: [],
  template_for: [],
  meta_id: null,
};

export const INITIAL_WHATSAPP_TEMPLATE_DATA: IWhatsAppTemplateData = {
  name: "",
  category: "",
  components: [],
  example: {
    header_text: [],
    body_text: [],
  },
  header: {
    type: "HEADER",
    format: null,
    text: null,
    example: {
      header_text: [],
      header_handle: null,
    },
  },
  body: {
    type: "BODY",
    text: "",
    example: {
      body_text: [],
    },
    value: {
      add_security_recommendation: true,
    },
  },
  buttons: {
    type: "BUTTONS",
    buttons: [],
  },
  footer: {
    type: "FOOTER",
    text: "",
    value: {
      code_expiration_minutes: null,
    },
  },

  company_outlet_uuid: "",
  whatsapp_template_uuid: null,
  meta_id: null,
};

export const initialWhatsAppTemplateData: IWhatsAppTemplateData = {
  company_outlet_uuid: "",
  name: "",
  category: "MARKETING",
  template_for: [],
  example: {
    header_text: [],
    body_text: [],
  },
  components: [],
  header: {
    type: "HEADER",
    format: null,
    text: null,
    example: {
      header_text: [],
      header_handle: null,
    },
  },
  body: {
    type: "BODY",
    text: "",
    example: {
      body_text: [],
    },
  },
  buttons: {
    type: "BUTTONS",
    buttons: [],
  },
  footer: {
    type: "FOOTER",
    text: "",
  },
  whatsapp_template_uuid: null,
  meta_id: null,
};

export const initialWhatsAppTemplateState: IWhatsAppTemplateState = {
  list: {
    list: [],
    totalRecords: 0,
    loading: LoadState.NotLoaded,
    error: null,
  },
  whatsAppTemplate: {
    data: initialWhatsAppTemplate,
    loading: LoadState.NotLoaded,
    error: null,
  },
  whatsAppTemplateData: {
    data: initialWhatsAppTemplateData,
    loading: LoadState.NotLoaded,
    error: null,
  },
};
